import { useUser } from '@shared/hooks';
import type { Event } from '@src/library/models/events';

export const useEventUser = (event: Event) => {
  const { user, isAuth } = useUser();
  const isAuthor = user?.id === event.author.id;

  return {
    isAuth,
    isAuthor,
    user,
  };
};
